export const ALL = '__all__'

// features
export const FEATURE_IMPORT_FROM_FILE = 'import_from_file'
export const FEATURE_STRIPE_ONBOARDING = 'stripe_onboarding'
